import Swiper, { Navigation } from 'swiper';

const arrow = `<svg width="32" height="32" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 1.00098C8.16344 1.00098 0.999998 8.16442 0.999999 17.001C0.999999 25.8375 8.16344 33.001 17 33.001C25.8366 33.001 33 25.8375 33 17.001C33 8.16442 25.8366 1.00098 17 1.00098Z" stroke="#141430" stroke-miterlimit="10"/>
<path d="M17.833 22.001L22.833 17.001L17.833 12.001" stroke="#141430" stroke-width="1.5" stroke-linecap="round"/>
<path d="M22 17.001L10.5 17.001" stroke="#141430" stroke-width="1.5" stroke-linecap="round"/>
</svg>
`;

export const patternTestimonials = () => {
  $('.pattern-testimonials')
    .removeClass('wp-block-group')
    .addClass('swiper')
    .children()
    .removeClass('wp-block-group__inner-container')
    .addClass('swiper-wrapper')
    .children('.pattern-testimonials-item')
    .removeClass('wp-block-group')
    .addClass('swiper-slide')
    .children()
    .children()
    .unwrap();

  $('.pattern-testimonials').append(
    `<button class="swiper-button-prev">${arrow}</button>`
  );
  $('.pattern-testimonials').append(
    `<button class="swiper-button-next">${arrow}</button>`
  );

  const swiper = new Swiper('.pattern-testimonials', {
    // Optional parameters
    //direction: 'horizontal',
    effect: 'fade',
    loop: true,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 64,
    speed: 500,
    autoHeight: true,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    modules: [Navigation],
  });
};
